module.exports = __webpack_public_path__ + "img/6.934d83e8.jpg";